{
  "HELP_CENTER": {
    "TITLE": "Помощен център",
    "NEW_PAGE": {
      "DESCRIPTION": "Създайте портали за самообслужване на клиентите си. Помогнете им да намират отговори бързо, без чакане. Опростете запитванията, повишете ефективността на агентите и издигнете нивото на клиентската поддръжка.",
      "CREATE_PORTAL_BUTTON": "Създай портал"
    },
    "NEW_ARTICLE_PAGE": {
      "PLACEHOLDER_TITLE": "Без заглавие"
    },
    "HEADER": {
      "FILTER": "Филтрирай по",
      "SORT": "Сортирай по",
      "LOCALE": "Език",
      "SETTINGS_BUTTON": "Настройки",
      "NEW_BUTTON": "Нова статия",
      "DROPDOWN_OPTIONS": {
        "PUBLISHED": "Публикувана",
        "DRAFT": "Draft",
        "ARCHIVED": "Архивирана"
      },
      "TITLES": {
        "ALL_ARTICLES": "Всички статии",
        "MINE": "Моите статии",
        "DRAFT": "Draft статии",
        "ARCHIVED": "Архивирани статии"
      },
      "LOCALE_SELECT": {
        "TITLE": "Избери език",
        "PLACEHOLDER": "Избери език",
        "NO_RESULT": "Няма намерен език",
        "SEARCH_PLACEHOLDER": "Търсене на език"
      }
    },
    "EDIT_HEADER": {
      "ALL_ARTICLES": "Всички статии",
      "PUBLISH_BUTTON": "Публикувай",
      "MOVE_TO_ARCHIVE_BUTTON": "Премести в архив",
      "PREVIEW": "Преглед",
      "ADD_TRANSLATION": "Добави превод",
      "OPEN_SIDEBAR": "Отвори страничната лента",
      "CLOSE_SIDEBAR": "Затвори страничната лента",
      "SAVING": "Запазване...",
      "SAVED": "Запазено"
    },
    "ARTICLE_EDITOR": {
      "IMAGE_UPLOAD": {
        "TITLE": "Качване на изображение",
        "UPLOADING": "Качване...",
        "SUCCESS": "Изображението е качено успешно",
        "ERROR": "Грешка при качване на изображението",
        "UN_AUTHORIZED_ERROR": "Нямате права да качвате изображения",
        "ERROR_FILE_SIZE": "Размерът на изображението трябва да е по-малък от {size}MB",
        "ERROR_FILE_FORMAT": "Форматът на изображението трябва да е jpg, jpeg или png",
        "ERROR_FILE_DIMENSIONS": "Размерите на изображението трябва да са по-малки от 2000 x 2000"
      },
      "ANCHOR": {
        "BUTTON": "Вмъкни котва",
        "TITLE": "Вмъкни котва",
        "SUBMIT": "Вмъкни",
        "PLACEHOLDER": "anchor-name"
      }
    },
    "ARTICLE_SETTINGS": {
      "TITLE": "Настройки на статията",
      "FORM": {
        "CATEGORY": {
          "LABEL": "Категория",
          "TITLE": "Избери категория",
          "PLACEHOLDER": "Избери категория",
          "NO_RESULT": "Няма намерена категория",
          "SEARCH_PLACEHOLDER": "Търсене на категория"
        },
        "AUTHOR": {
          "LABEL": "Автор",
          "TITLE": "Избери автор",
          "PLACEHOLDER": "Избери автор",
          "NO_RESULT": "Няма намерени автори",
          "SEARCH_PLACEHOLDER": "Търсене на автор"
        },
        "META_TITLE": {
          "LABEL": "Мета заглавие",
          "PLACEHOLDER": "Добави мета заглавие"
        },
        "META_DESCRIPTION": {
          "LABEL": "Мета описание",
          "PLACEHOLDER": "Добавете мета описание за по-добри SEO резултати..."
        },
        "META_TAGS": {
          "LABEL": "Мета тагове",
          "PLACEHOLDER": "Добавете мета тагове, разделени със запетая..."
        }
      },
      "BUTTONS": {
        "ARCHIVE": "Архивирай статията",
        "DELETE": "Изтрий статията"
      }
    },
    "ARTICLE_SEARCH_RESULT": {
      "UNCATEGORIZED": "Без категория",
      "SEARCH_RESULTS": "Резултати от търсенето за {query}",
      "EMPTY_TEXT": "Търсете статии, за да ги вмъкнете в отговорите.",
      "SEARCH_LOADER": "Търсене...",
      "INSERT_ARTICLE": "Вмъкни",
      "NO_RESULT": "Няма намерени статии",
      "COPY_LINK": "Копирай връзка към статията в клипборда",
      "OPEN_LINK": "Отвори статията в нов раздел",
      "PREVIEW_LINK": "Преглед на статията"
    },
    "PORTAL": {
      "HEADER": "Портали",
      "DEFAULT": "По подразбиране",
      "NEW_BUTTON": "Нов портал",
      "ACTIVE_BADGE": "активен",
      "CHOOSE_LOCALE_LABEL": "Изберете език",
      "LOADING_MESSAGE": "Зареждане на порталите...",
      "ARTICLES_LABEL": "статии",
      "NO_PORTALS_MESSAGE": "Няма налични портали",
      "ADD_NEW_LOCALE": "Добави нов език",
      "POPOVER": {
        "TITLE": "Портали",
        "PORTAL_SETTINGS": "Настройки на портала",
        "SUBTITLE": "Имате няколко портала и можете да зададете различни езици за всеки портал.",
        "CANCEL_BUTTON_LABEL": "Отмени",
        "CHOOSE_LOCALE_BUTTON": "Избери език"
      },
      "PORTAL_SETTINGS": {
        "LIST_ITEM": {
          "HEADER": {
            "COUNT_LABEL": "статии",
            "ADD": "Добави език",
            "VISIT": "Посети сайта",
            "SETTINGS": "Настройки",
            "DELETE": "Изтрий"
          },
          "PORTAL_CONFIG": {
            "TITLE": "Конфигурации на портала",
            "ITEMS": {
              "NAME": "Име",
              "DOMAIN": "Персонализиран домейн",
              "SLUG": "Slug",
              "TITLE": "Заглавие на портала",
              "THEME": "Цвят на темата",
              "SUB_TEXT": "Подтекст на портала"
            }
          },
          "AVAILABLE_LOCALES": {
            "TITLE": "Налични езици",
            "TABLE": {
              "NAME": "Име на езика",
              "CODE": "Код на езика",
              "ARTICLE_COUNT": "Бр. статии",
              "CATEGORIES": "Бр. категории",
              "SWAP": "Размени",
              "DELETE": "Изтрий",
              "DEFAULT_LOCALE": "По подразбиране"
            }
          }
        },
        "DELETE_PORTAL": {
          "TITLE": "Изтриване на портал",
          "MESSAGE": "Сигурни ли сте, че искате да изтриете този портал",
          "YES": "Да, изтрий портала",
          "NO": "Не, запази портала",
          "API": {
            "DELETE_SUCCESS": "Порталът е изтрит успешно",
            "DELETE_ERROR": "Грешка при изтриване на портала"
          }
        }
      },
      "EDIT": {
        "HEADER_TEXT": "Редактиране на портал",
        "TABS": {
          "BASIC_SETTINGS": {
            "TITLE": "Основна информация"
          },
          "CUSTOMIZATION_SETTINGS": {
            "TITLE": "Персонализация на портала"
          },
          "CATEGORY_SETTINGS": {
            "TITLE": "Категории"
          },
          "LOCALE_SETTINGS": {
            "TITLE": "Езици"
          }
        },
        "CATEGORIES": {
          "TITLE": "Категории в",
          "NEW_CATEGORY": "Нова категория",
          "TABLE": {
            "NAME": "Име",
            "DESCRIPTION": "Описание",
            "LOCALE": "Език",
            "ARTICLE_COUNT": "Бр. статии",
            "ACTION_BUTTON": {
              "EDIT": "Редактирай категория",
              "DELETE": "Изтрий категория"
            },
            "EMPTY_TEXT": "Няма намерени категории"
          }
        },
        "EDIT_BASIC_INFO": {
          "BUTTON_TEXT": "Обнови основните настройки"
        }
      },
      "ADD": {
        "CREATE_FLOW": {
          "BASIC": {
            "TITLE": "Информация за помощния център",
            "BODY": "Основна информация за портала"
          },
          "CUSTOMIZATION": {
            "TITLE": "Персонализация на помощния център",
            "BODY": "Персонализирай портала"
          },
          "FINISH": {
            "TITLE": "Готово! 🎉",
            "BODY": "Всичко е готово!"
          }
        },
        "CREATE_FLOW_PAGE": {
          "BACK_BUTTON": "Назад",
          "BASIC_SETTINGS_PAGE": {
            "HEADER": "Създаване на портал",
            "TITLE": "Информация за помощния център",
            "CREATE_BASIC_SETTING_BUTTON": "Създай основни настройки на портала"
          },
          "CUSTOMIZATION_PAGE": {
            "HEADER": "Персонализация на портала",
            "TITLE": "Персонализация на помощния център",
            "UPDATE_PORTAL_BUTTON": "Обнови настройките на портала"
          },
          "FINISH_PAGE": {
            "TITLE": "Готово! 🎉 Всичко е настроено!",
            "MESSAGE": "Вече можете да видите създадения портал в страницата с всички портали.",
            "FINISH": "Към страницата с всички портали"
          }
        },
        "LOGO": {
          "LABEL": "Лого",
          "UPLOAD_BUTTON": "Качи лого",
          "HELP_TEXT": "Това лого ще се показва в заглавната част на портала.",
          "IMAGE_UPLOAD_SUCCESS": "Логото е качено успешно",
          "IMAGE_UPLOAD_ERROR": "Логото е изтрито успешно",
          "IMAGE_DELETE_ERROR": "Грешка при изтриване на логото"
        },
        "NAME": {
          "LABEL": "Име",
          "PLACEHOLDER": "Име на портала",
          "HELP_TEXT": "Името ще се използва вътрешно в публичния портал.",
          "ERROR": "Името е задължително"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug на портала за URL адреси",
          "ERROR": "Slug е задължителен"
        },
        "DOMAIN": {
          "LABEL": "Персонализиран домейн",
          "PLACEHOLDER": "Персонализиран домейн на портала",
          "HELP_TEXT": "Добавете само ако искате да използвате персонализиран домейн за порталите си. Напр.: {exampleURL}",
          "ERROR": "Въведете валиден URL адрес на домейн"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Връзка към начална страница",
          "PLACEHOLDER": "Връзка към началната страница на портала",
          "HELP_TEXT": "Връзката, използвана за връщане от портала към началната страница. Напр.: {exampleURL}",
          "ERROR": "Въведете валиден URL адрес на начална страница"
        },
        "THEME_COLOR": {
          "LABEL": "Цвят на темата на портала",
          "HELP_TEXT": "Този цвят ще се показва като цвят на темата на портала."
        },
        "PAGE_TITLE": {
          "LABEL": "Заглавие на страницата",
          "PLACEHOLDER": "Заглавие на страницата на портала",
          "HELP_TEXT": "Заглавието на страницата ще се използва в публичния портал.",
          "ERROR": "Заглавието на страницата е задължително"
        },
        "HEADER_TEXT": {
          "LABEL": "Текст на заглавната част",
          "PLACEHOLDER": "Текст на заглавната част на портала",
          "HELP_TEXT": "Текстът на заглавната част на портала ще се използва в публичния портал.",
          "ERROR": "Текстът на заглавната част на портала е задължителен"
        },
        "API": {
          "SUCCESS_MESSAGE_FOR_BASIC": "Порталът е създаден успешно.",
          "ERROR_MESSAGE_FOR_BASIC": "Порталът не можа да бъде създаден. Опитайте отново.",
          "SUCCESS_MESSAGE_FOR_UPDATE": "Порталът е обновен успешно.",
          "ERROR_MESSAGE_FOR_UPDATE": "Порталът не можа да бъде обновен. Опитайте отново."
        }
      },
      "ADD_LOCALE": {
        "TITLE": "Добави нов език",
        "SUB_TITLE": "Това добавя нов език към списъка с налични преводи.",
        "PORTAL": "Портал",
        "LOCALE": {
          "LABEL": "Език",
          "PLACEHOLDER": "Изберете език",
          "ERROR": "Езикът е задължителен"
        },
        "BUTTONS": {
          "CREATE": "Добави език",
          "CANCEL": "Отмени"
        },
        "API": {
          "SUCCESS_MESSAGE": "Езикът е добавен успешно",
          "ERROR_MESSAGE": "Неуспешно добавяне на език. Опитайте отново."
        }
      },
      "CHANGE_DEFAULT_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Езикът по подразбиране е обновен успешно",
          "ERROR_MESSAGE": "Неуспешно обновяване на езика по подразбиране. Опитайте отново."
        }
      },
      "DELETE_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Езикът е премахнат от портала успешно",
          "ERROR_MESSAGE": "Неуспешно премахване на езика от портала. Опитайте отново."
        }
      }
    },
    "TABLE": {
      "404": "Няма статии, отговарящи на търсенето 🔍",
      "LOADING_MESSAGE": "Зареждане на статиите...",
      "NO_ARTICLES": "Няма налични статии",
      "HEADERS": {
        "TITLE": "Заглавие",
        "CATEGORY": "Категория",
        "READ_COUNT": "Прегледи",
        "STATUS": "Статус",
        "LAST_EDITED": "Последно редактирано"
      },
      "COLUMNS": {
        "BY": "от",
        "AUTHOR_NOT_AVAILABLE": "Авторът не е наличен"
      }
    },
    "EDIT_ARTICLE": {
      "LOADING": "Зареждане на статията...",
      "TITLE_PLACEHOLDER": "Заглавието на статията отива тук",
      "CONTENT_PLACEHOLDER": "Напишете статията си тук",
      "API": {
        "ERROR": "Грешка при запазване на статията"
      }
    },
    "PUBLISH_ARTICLE": {
      "API": {
        "ERROR": "Грешка при публикуване на статията",
        "SUCCESS": "Статията е публикувана успешно"
      }
    },
    "ARCHIVE_ARTICLE": {
      "API": {
        "ERROR": "Грешка при архивиране на статията",
        "SUCCESS": "Статията е архивирана успешно"
      }
    },
    "DRAFT_ARTICLE": {
      "API": {
        "ERROR": "Грешка при задаване на статията като Draft",
        "SUCCESS": "Статията е зададена като Draft успешно"
      }
    },
    "DELETE_ARTICLE": {
      "MODAL": {
        "CONFIRM": {
          "TITLE": "Потвърди изтриването",
          "MESSAGE": "Сигурни ли сте, че искате да изтриете статията?",
          "YES": "Да, изтрий",
          "NO": "Не, запази"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Статията е изтрита успешно",
        "ERROR_MESSAGE": "Грешка при изтриване на статията"
      }
    },
    "CREATE_ARTICLE": {
      "ERROR_MESSAGE": "Моля, добавете заглавие и съдържание на статията, за да можете да обновите настройките"
    },
    "SIDEBAR": {
      "SEARCH": {
        "PLACEHOLDER": "Търсене на статии"
      }
    },
    "CATEGORY": {
      "ADD": {
        "TITLE": "Създаване на категория",
        "SUB_TITLE": "Категорията ще се използва в публичния портал за категоризиране на статии.",
        "PORTAL": "Портал",
        "LOCALE": "Език",
        "NAME": {
          "LABEL": "Име",
          "PLACEHOLDER": "Име на категорията",
          "HELP_TEXT": "Името и иконата на категорията ще се използват в публичния портал за категоризиране на статии.",
          "ERROR": "Името е задължително"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug на категорията за URL адреси",
          "HELP_TEXT": "chat.jarabot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "Slug е задължителен"
        },
        "DESCRIPTION": {
          "LABEL": "Описание",
          "PLACEHOLDER": "Дайте кратко описание на категорията.",
          "ERROR": "Описанието е задължително"
        },
        "BUTTONS": {
          "CREATE": "Създай категория",
          "CANCEL": "Отмени"
        },
        "API": {
          "SUCCESS_MESSAGE": "Категорията е създадена успешно",
          "ERROR_MESSAGE": "Неуспешно създаване на категория"
        }
      },
      "EDIT": {
        "TITLE": "Редактиране на категория",
        "SUB_TITLE": "Редактирането на категория ще я обнови в публичния портал.",
        "PORTAL": "Портал",
        "LOCALE": "Език",
        "NAME": {
          "LABEL": "Име",
          "PLACEHOLDER": "Име на категорията",
          "HELP_TEXT": "Името и иконата на категорията ще се използват в публичния портал за категоризиране на статии.",
          "ERROR": "Името е задължително"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug на категорията за URL адреси",
          "HELP_TEXT": "chat.jarabot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "Slug е задължителен"
        },
        "DESCRIPTION": {
          "LABEL": "Описание",
          "PLACEHOLDER": "Дайте кратко описание на категорията.",
          "ERROR": "Описанието е задължително"
        },
        "BUTTONS": {
          "CREATE": "Обнови категория",
          "CANCEL": "Отмени"
        },
        "API": {
          "SUCCESS_MESSAGE": "Категорията е обновена успешно",
          "ERROR_MESSAGE": "Неуспешно обновяване на категория"
        }
      },
      "DELETE": {
        "API": {
          "SUCCESS_MESSAGE": "Категорията е изтрита успешно",
          "ERROR_MESSAGE": "Неуспешно изтриване на категория"
        }
      }
    },
    "ARTICLE_SEARCH": {
      "TITLE": "Търсене на статии",
      "PLACEHOLDER": "Търсене на статии",
      "NO_RESULT": "Няма намерени статии",
      "SEARCHING": "Търсене...",
      "SEARCH_BUTTON": "Търсене",
      "INSERT_ARTICLE": "Вмъкни връзка",
      "IFRAME_ERROR": "URL адресът е празен или невалиден. Съдържанието не може да бъде показано.",
      "OPEN_ARTICLE_SEARCH": "Вмъкни статия от помощния център",
      "SUCCESS_ARTICLE_INSERTED": "Статията е вмъкната успешно",
      "PREVIEW_LINK": "Преглед на статията",
      "CANCEL": "Затвори",
      "BACK": "Назад",
      "BACK_RESULTS": "Обратно към резултатите"
    },
    "UPGRADE_PAGE": {
      "TITLE": "Помощен център",
      "DESCRIPTION": "Създайте удобни портали за самообслужване. Помогнете на потребителите си да получат достъп до статиите и поддръжка 24/7. Надградете абонамента си, за да активирате тази функция.",
      "SELF_HOSTED_DESCRIPTION": "Създайте удобни портали за самообслужване. Помогнете на потребителите си да получат достъп до статиите и поддръжка 24/7. Свържете се с администратора си, за да активирате тази функция.",
      "BUTTON": {
        "LEARN_MORE": "Научи повече",
        "UPGRADE": "Надгради"
      },
      "FEATURES": {
        "PORTALS": {
          "TITLE": "Множество портали",
          "DESCRIPTION": "Създавайте множество портали за помощен център за различни продукти, използвайки един и същ акаунт."
        },
        "LOCALES": {
          "TITLE": "Пълна поддръжка на езици",
          "DESCRIPTION": "Локализирайте портала на вашия език. Поддържаме всички езици и позволяваме превод на всяка статия."
        },
        "SEO": {
          "TITLE": "SEO-съобразен дизайн",
          "DESCRIPTION": "Персонализирайте мета таговете си, за да подобрите видимостта си в търсачките с нашите SEO-съобразени страници."
        },
        "API": {
          "TITLE": "Пълна поддръжка на API",
          "DESCRIPTION": "Използвайте портала като headless CMS с front-end frameworks на трети страни чрез нашите API."
        }
      }
    },
    "LOADING": "Зареждане...",
    "ARTICLES_PAGE": {
      "ARTICLE_CARD": {
        "CARD": {
          "VIEWS": "{count} преглед | {count} прегледа",
          "DROPDOWN_MENU": {
            "PUBLISH": "Публикувай",
            "DRAFT": "Draft",
            "ARCHIVE": "Архивирай",
            "DELETE": "Изтрий"
          },
          "STATUS": {
            "DRAFT": "Draft",
            "PUBLISHED": "Публикувана",
            "ARCHIVED": "Архивирана"
          },
          "CATEGORY": {
            "UNCATEGORISED": "Без категория"
          }
        }
      },
      "ARTICLES_HEADER": {
        "TABS": {
          "ALL": "Всички статии",
          "MINE": "Мои",
          "DRAFT": "Draft",
          "PUBLISHED": "Публикувани",
          "ARCHIVED": "Архивирани"
        },
        "CATEGORY": {
          "ALL": "Всички категории"
        },
        "LOCALE": {
          "ALL": "Всички езици"
        },
        "NEW_ARTICLE": "Нова статия"
      },
      "EMPTY_STATE": {
        "ALL": {
          "TITLE": "Напишете статия",
          "SUBTITLE": "Напишете подробна статия, да започваме!",
          "BUTTON_LABEL": "Нова статия"
        },
        "MINE": {
          "TITLE": "Все още не сте написали статии тук",
          "SUBTITLE": "Всички статии, написани от вас, се показват тук за бърз достъп."
        },
        "DRAFT": {
          "TITLE": "Няма статии в Draft",
          "SUBTITLE": "Draft статии ще се показват тук"
        },
        "PUBLISHED": {
          "TITLE": "Няма публикувани статии",
          "SUBTITLE": "Публикуваните статии ще се показват тук"
        },
        "ARCHIVED": {
          "TITLE": "Няма статии в архива",
          "SUBTITLE": "Архивираните статии не се показват в портала, можете да ги използвате за да отбележите остарели или неактуални страници"
        },
        "CATEGORY": {
          "TITLE": "Няма статии в тази категория",
          "SUBTITLE": "Статиите от тази категория ще се показват тук"
        }
      }
    },
    "CATEGORY_PAGE": {
      "CATEGORY_HEADER": {
        "NEW_CATEGORY": "Нова категория",
        "EDIT_CATEGORY": "Редактирай категория",
        "CATEGORIES_COUNT": "{n} категория | {n} категории",
        "BREADCRUMB": {
          "CATEGORY_LOCALE": "Категории ({localeCode})",
          "ACTIVE_CATEGORY": "{categoryName} ({categoryCount} статии) | {categoryName} ({categoryCount} статия)"
        }
      },
      "CATEGORY_EMPTY_STATE": {
        "TITLE": "Няма намерени категории",
        "SUBTITLE": "Категориите ще се показват тук. Можете да добавите категория, като натиснете бутона „Нова категория“."
      },
      "CATEGORY_CARD": {
        "ARTICLES_COUNT": "{count} статия | {count} статии",
        "EXPAND": "Покажи подкатегориите",
        "COLLAPSE": "Скрий подкатегориите",
        "MENU": {
          "NEW_ARTICLE": "Нова статия",
          "ADD_SUBCATEGORY": "Добави подкатегория",
          "EDIT": "Редактирай",
          "DELETE": "Изтрий"
        }
      },
      "CATEGORY_DIALOG": {
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Категорията е създадена успешно",
            "ERROR_MESSAGE": "Неуспешно създаване на категория"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Категорията е обновена успешно",
            "ERROR_MESSAGE": "Неуспешно обновяване на категория"
          }
        },
        "DELETE": {
          "API": {
            "SUCCESS_MESSAGE": "Категорията е изтрита успешно",
            "ERROR_MESSAGE": "Неуспешно изтриване на категория"
          },
          "CONFIRM": {
            "TITLE": "Изтриване на категория",
            "DESCRIPTION": "Сигурни ли сте, че искате да изтриете тази категория? Нейните статии ще останат без категория.",
            "DESCRIPTION_WITH_CHILDREN": "Сигурни ли сте, че искате да изтриете тази категория? Нейните статии ще останат без категория, а нейната {count} подкатегория ще бъде преместена на най-горното ниво. | Сигурни ли сте, че искате да изтриете тази категория? Нейните статии ще останат без категория, а нейните {count} подкатегории ще бъдат преместени на най-горното ниво.",
            "CONFIRM": "Изтрий"
          }
        },
        "HEADER": {
          "CREATE": "Създай категория",
          "EDIT": "Редактирай категория",
          "DESCRIPTION": "Редактирането на категория ще я обнови в публичния портал.",
          "PORTAL": "Портал",
          "LOCALE": "Език"
        },
        "FORM": {
          "NAME": {
            "LABEL": "Име",
            "PLACEHOLDER": "Име на категорията",
            "ERROR": "Името е задължително"
          },
          "SLUG": {
            "LABEL": "Slug",
            "PLACEHOLDER": "Slug на категорията за URL адреси",
            "ERROR": "Slug е задължителен",
            "HELP_TEXT": "chat.jarabot.com/hc/{portalSlug}/{localeCode}/categories/{categorySlug}"
          },
          "DESCRIPTION": {
            "LABEL": "Описание",
            "PLACEHOLDER": "Дайте кратко описание на категорията.",
            "ERROR": "Описанието е задължително"
          },
          "PARENT_CATEGORY": {
            "LABEL": "Родителска категория",
            "PLACEHOLDER": "Изберете родителска категория",
            "NONE": "Няма (най-горно ниво)"
          }
        },
        "BUTTONS": {
          "CREATE": "Създаване",
          "EDIT": "Обновяване",
          "CANCEL": "Отмени"
        }
      }
    },
    "LOCALES_PAGE": {
      "LOCALES_COUNT": "Няма налични езици | {n} език | {n} езика",
      "NEW_LOCALE_BUTTON_TEXT": "Нов език",
      "LOCALE_CARD": {
        "ARTICLES_COUNT": "{count} статия | {count} статии",
        "CATEGORIES_COUNT": "{count} категория | {count} категории",
        "DEFAULT": "По подразбиране",
        "DROPDOWN_MENU": {
          "MAKE_DEFAULT": "Задай по подразбиране",
          "DELETE": "Изтрий"
        }
      },
      "ADD_LOCALE_DIALOG": {
        "TITLE": "Добави нов език",
        "DESCRIPTION": "Изберете езика, на който ще бъде написана тази статия. Той ще бъде добавен към списъка ви с преводи и можете да добавите още по-късно.",
        "COMBOBOX": {
          "PLACEHOLDER": "Избери език..."
        },
        "API": {
          "SUCCESS_MESSAGE": "Езикът е добавен успешно",
          "ERROR_MESSAGE": "Неуспешно добавяне на език. Опитайте отново."
        }
      }
    },
    "EDIT_ARTICLE_PAGE": {
      "HEADER": {
        "STATUS": {
          "SAVING": "Запазване...",
          "SAVED": "Запазено"
        },
        "PREVIEW": "Преглед",
        "PUBLISH": "Публикувай",
        "DRAFT": "Draft",
        "ARCHIVE": "Архивирай",
        "BACK_TO_ARTICLES": "Обратно към статиите"
      },
      "DRAFT": {
        "PENDING_LABEL": "Непубликувани промени",
        "PROMOTE": "Публикувай промените",
        "DISCARD": "Отхвърли промените",
        "PROMOTE_SUCCESS": "Промените от чернова са публикувани в активната статия",
        "PROMOTE_ERROR": "Промените от чернова не можаха да бъдат публикувани",
        "DISCARD_SUCCESS": "Промените от чернова бяха отхвърлени",
        "DISCARD_ERROR": "Промените от чернова не можаха да бъдат отхвърлени"
      },
      "VERSION_HISTORY": {
        "MENU_ITEM": "История на версиите",
        "TITLE": "История на версиите",
        "BACK": "Обратно към статията",
        "LOADING": "Зареждане на версиите...",
        "EMPTY": "Все още няма версии. Промените по тази статия ще се показват тук.",
        "EMPTY_CONTENT": "Тази версия няма съдържание.",
        "CURRENT_BADGE": "Текуща",
        "RESTORED_BADGE": "Възстановена",
        "AUTOMATED_USER": "Автоматична актуализация",
        "RESTORE": "Възстанови тази версия",
        "RESTORE_DIALOG": {
          "TITLE": "Да възстановите ли тази версия?",
          "DESCRIPTION": "Статията ще се върне към текста на тази версия. Нищо не се губи — текущият текст остава в историята, а публикуваната статия продължава да показва активната версия, докато не публикувате промяната.",
          "CONFIRM": "Възстанови"
        },
        "RESTORE_SUCCESS": "Версията е възстановена",
        "RESTORE_ERROR": "Тази версия не можа да бъде възстановена",
        "FETCH_ERROR": "Историята на версиите не можа да бъде заредена"
      },
      "EDIT_ARTICLE": {
        "MORE_PROPERTIES": "Още свойства",
        "TRANSLATE": "Преведи",
        "SOURCE": "Markdown",
        "UNCATEGORIZED": "Без категория",
        "EDITOR_PLACEHOLDER": "Напишете нещо...",
        "HTML_EMBED": {
          "TITLE": "Вмъкване на персонализиран HTML",
          "DESCRIPTION": "Поставете суров HTML, например iframe, embed или widget фрагмент. Ще бъде показан както е в публикуваната статия.",
          "PLACEHOLDER": "<iframe src=\"https://...\"></iframe>",
          "INSERT": "Вмъкване"
        },
        "PRIMARY_CATEGORY": "Основна категория"
      },
      "ARTICLE_PROPERTIES": {
        "ARTICLE_PROPERTIES": "Свойства на статията",
        "SLUG": "Slug",
        "EDIT_SLUG": "Edit slug",
        "META_DESCRIPTION": "Мета описание",
        "META_DESCRIPTION_PLACEHOLDER": "Добавете мета описание",
        "META_TITLE": "Мета заглавие",
        "META_TITLE_PLACEHOLDER": "Добавете мета заглавие",
        "META_TAGS": "Мета тагове",
        "META_TAGS_PLACEHOLDER": "Добавете мета тагове",
        "SET_AS_HOMEPAGE": "Set as homepage",
        "SET_AS_HOMEPAGE_HELP": "Show this article as the help center homepage for this language. Add {'{{NAV}}'} in the content to include search + categories.",
        "LANGUAGE_MUTATIONS": "Езикови версии",
        "LANGUAGE_MUTATIONS_EMPTY": "Все още няма свързани статии",
        "ADD_MUTATION": "Добави",
        "REMOVE_MUTATION": "Премахни"
      },
      "LANGUAGE_MUTATIONS_DIALOG": {
        "TITLE": "Свържи езиковите версии",
        "SEARCH_PLACEHOLDER": "Търсене на статии по заглавие",
        "EMPTY": "Няма съответстващи статии",
        "CANCEL": "Отказ",
        "ADD_SELECTED": "Добави избраните",
        "SUCCESS": "Версиите са обновени",
        "ERROR": "Неуспешно обновяване на версиите"
      },
      "TRANSLATE_DIALOG": {
        "TITLE": "Преведи статията",
        "DESCRIPTION": "Изберете езиците, на които искате да преведете тази статия. Езиците, които вече са преведени, ще бъдат преведени отново в Draft за преглед.",
        "EMPTY": "Няма налични други езици",
        "CONNECTED_BADGE": "Преведено",
        "CANCEL": "Отказ",
        "TRANSLATE": "Преведи",
        "SUCCESS": "Преводът ще започне скоро. Преведените статии скоро ще се появят като езикови версии.",
        "ERROR": "Неуспешно стартиране на превода"
      },
      "SLUG_DIALOG": {
        "TITLE": "Edit article URL",
        "DESCRIPTION": "Change the descriptive part of this article's slug. Old links keep working — they redirect here automatically.",
        "INPUT_LABEL": "Slug",
        "PLACEHOLDER": "getting-started",
        "PREFIX_HINT": "The numeric prefix is a permanent identifier and cannot be changed.",
        "PREVIEW": "Article URL",
        "CANCEL": "Cancel",
        "SAVE": "Save",
        "SUCCESS": "Article URL updated",
        "ERROR": "Failed to update the article URL"
      },
      "API": {
        "ERROR": "Грешка при запазване на статията"
      }
    },
    "PORTAL_SWITCHER": {
      "NEW_PORTAL": "Нов портал",
      "PORTALS": "Портали",
      "CREATE_PORTAL": "Създавай и управлявай множество портали",
      "ARTICLES": "статии",
      "DOMAIN": "домейн",
      "PORTAL_NAME": "Име на портала"
    },
    "CREATE_PORTAL_DIALOG": {
      "TITLE": "Създаване на нов портал",
      "DESCRIPTION": "Дайте име на портала си и създайте удобен URL slug. Можете да промените и двете по-късно в настройките.",
      "CONFIRM_BUTTON_LABEL": "Създаване",
      "NAME": {
        "LABEL": "Име",
        "PLACEHOLDER": "Ръководство за потребителя",
        "MESSAGE": "Изберете име за портала си.",
        "ERROR": "Името е задължително"
      },
      "SLUG": {
        "LABEL": "Slug",
        "PLACEHOLDER": "user-guide",
        "ERROR": "Slug е задължителен",
        "FORMAT_ERROR": "Използвайте само букви, цифри и тирета, например: user-guide"
      }
    },
    "PORTAL_SETTINGS": {
      "FORM": {
        "AVATAR": {
          "LABEL": "Лого",
          "IMAGE_UPLOAD_ERROR": "Неуспешно качване на изображение! Опитайте отново",
          "IMAGE_UPLOAD_SUCCESS": "Изображението е добавено успешно. Моля, натиснете „Запази промените“, за да запазите логото",
          "IMAGE_DELETE_SUCCESS": "Логото е изтрито успешно",
          "IMAGE_DELETE_ERROR": "Неуспешно изтриване на логото",
          "IMAGE_UPLOAD_SIZE_ERROR": "Размерът на изображението трябва да е по-малък от {size}MB"
        },
        "HERO_IMAGE": {
          "LABEL": "Hero image",
          "HELP_TEXT": "Optional full-width background image shown behind the centered search box on the help center homepage.",
          "IMAGE_UPLOAD_ERROR": "Couldn't upload image! Try again",
          "IMAGE_UPLOAD_SUCCESS": "Image added successfully. Please click on save changes to save the hero image",
          "IMAGE_DELETE_SUCCESS": "Hero image deleted successfully",
          "IMAGE_DELETE_ERROR": "Unable to delete hero image",
          "IMAGE_UPLOAD_SIZE_ERROR": "Image size should be less than {size}MB"
        },
        "HOMEPAGE_ARTICLES": {
          "LABEL": "Homepage articles",
          "EMPTY": "No article is set as the homepage. Set one from an article's properties.",
          "HELP_TEXT": "The article shown as the homepage for each language. Click to open it, or remove to restore the default homepage.",
          "REMOVE": "Remove",
          "REMOVE_SUCCESS": "Homepage article removed",
          "REMOVE_ERROR": "Unable to remove homepage article"
        },
        "NAME": {
          "LABEL": "Име",
          "PLACEHOLDER": "Име на портала",
          "ERROR": "Името е задължително"
        },
        "HEADER_TEXT": {
          "LABEL": "Текст на заглавната част",
          "PLACEHOLDER": "Текст на заглавната част на портала"
        },
        "PAGE_TITLE": {
          "LABEL": "Заглавие на страницата",
          "PLACEHOLDER": "Заглавие на страницата на портала"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Връзка към началната страница",
          "PLACEHOLDER": "Връзка към началната страница на портала",
          "ERROR": "Невалиден URL адрес. Връзката към началната страница трябва да започва с 'http://' или 'https://'."
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug на портала"
        },
        "LIVE_CHAT_WIDGET": {
          "LABEL": "Уиджет за жив чат",
          "PLACEHOLDER": "Изберете уиджет за жив чат",
          "HELP_TEXT": "Изберете уиджет за жив чат, който ще се показва във вашия помощен център"
        },
        "PUBLIC_ACCESS": {
          "LABEL": "Публично достъпен",
          "HELP_TEXT": "Направете портала достъпен за всички с връзка.",
          "OPTIONS": {
            "PUBLIC": "Да",
            "PRIVATE": "Не"
          }
        },
        "LINK_TARGET": {
          "LABEL": "Цел на връзката",
          "HELP_TEXT": "Изберете дали връзките в статиите да се отварят в текущия прозорец или в нов.",
          "OPTIONS": {
            "CURRENT_WINDOW": "Текущ прозорец",
            "NEW_WINDOW": "Нов прозорец"
          }
        },
        "DEFAULT_IMAGE_SIZE": {
          "LABEL": "Размер на изображението по подразбиране",
          "HELP_TEXT": "Размерът, който се прилага към всяко изображение, което вмъквате в статия. Изберете Оригинален, за да вмъквате изображения в собствения им размер и да избирате размер за всяко изображение вместо това."
        },
        "BRAND_COLOR": {
          "LABEL": "Цвят на марката"
        },
        "CUSTOM_HTML": {
          "LABEL": "Персонализиран HTML",
          "PLACEHOLDER": "<!-- Поставете тук фрагмента си за анализи или проследяване -->",
          "HELP_TEXT": "Вмъква се в началото на тага <body> на всяка страница на помощния център. Използвайте го за Google Analytics, Google Tag Manager или друг фрагмент код за проследяване. Кодът се визуализира точно както е въведен и не се валидира."
        },
        "SAVE_CHANGES": "Запази промените"
      },
      "CONFIGURATION_FORM": {
        "CUSTOM_DOMAIN": {
          "HEADER": "Персонализиран домейн",
          "LABEL": "Персонализиран домейн:",
          "DESCRIPTION": "Можете да хоствате портала си на персонализиран домейн. Например, ако сайтът ви е yourdomain.com и искате порталът ви да е достъпен на docs.yourdomain.com, просто въведете това в полето.",
          "PLACEHOLDER": "Персонализиран домейн на портала",
          "EDIT_BUTTON": "Редактирай персонализирания домейн",
          "ADD_BUTTON": "Добави персонализиран домейн",
          "DIALOG": {
            "ADD_HEADER": "Добави персонализиран домейн",
            "EDIT_HEADER": "Редактирай персонализирания домейн",
            "ADD_CONFIRM_BUTTON_LABEL": "Добави домейн",
            "EDIT_CONFIRM_BUTTON_LABEL": "Обнови домейна",
            "LABEL": "Персонализиран домейн",
            "PLACEHOLDER": "Персонализиран домейн на портала",
            "ERROR": "Персонализираният домейн е задължителен"
          },
          "DNS_CONFIGURATION_DIALOG": {
            "HEADER": "DNS конфигурация",
            "DESCRIPTION": "Влезте в акаунта си при вашия DNS доставчик и добавете CNAME записа по-долу за вашия поддомейн.",
            "HELP_TEXT": "След като направите това, можете да се свържете с нашата поддръжка, за да заявите автоматично генериран SSL сертификат.",
            "CONFIRM_BUTTON_LABEL": "Разбрах!"
          }
        },
        "DELETE_PORTAL": {
          "BUTTON": "Изтрий {portalName}",
          "HEADER": "Изтриване на портал",
          "DESCRIPTION": "Окончателно изтриване на този портал. Това действие е необратимо",
          "DIALOG": {
            "HEADER": "Сигурни ли сте, че искате да изтриете {portalName}?",
            "DESCRIPTION": "Това е окончателно действие, което не може да бъде отменено.",
            "CONFIRM_BUTTON_LABEL": "Изтрий"
          }
        },
        "EDIT_CONFIGURATION": "Редактирай конфигурацията"
      },
      "API": {
        "CREATE_PORTAL": {
          "SUCCESS_MESSAGE": "Порталът е създаден успешно",
          "ERROR_MESSAGE": "Неуспешно създаване на портал"
        },
        "UPDATE_PORTAL": {
          "SUCCESS_MESSAGE": "Порталът е обновен успешно",
          "ERROR_MESSAGE": "Неуспешно обновяване на портал"
        }
      }
    },
    "ATTACHMENTS": {
      "TITLE": "Прикачени файлове",
      "DRAFT_BADGE": "Draft",
      "ADD_BUTTON": "Добави файл",
      "DROP_HERE": "Плъзнете и пуснете файлове тук",
      "COPY_LINK": "Копирай връзка",
      "LINK_COPIED": "Връзката е копирана в клипборда",
      "COPY_FAILED": "Неуспешно копиране на връзката",
      "DELETE": "Изтрий",
      "CANCEL": "Отмени",
      "QUEUED": "На опашка",
      "UPLOADING": "Качване",
      "UPLOAD_FAILED": "Неуспешно качване на файла",
      "FILE_TOO_LARGE": "Файлът надвишава лимита от 40 MB"
    },
    "DICTIONARY_PAGE": {
      "HEADER": {
        "TITLE": "Речник за превод",
        "DESCRIPTION": "Дефинираните тук термини се добавят към AI промпта за превод, за да бъдат винаги превеждани по един и същ начин. Ключовият термин е написан на {locale}."
      },
      "NEW_TERM": "Нов термин",
      "EMPTY_STATE": {
        "TITLE": "Все още няма термини в речника",
        "SUBTITLE": "Добавете термин и превода му за всеки език. Когато дадена статия бъде преведена, тези термини се прилагат задължително, за да остане терминологията на продукта ви последователна."
      },
      "LIST": {
        "TERM": "Термин",
        "TRANSLATIONS": "Преводи",
        "ACTIONS": "Действия"
      },
      "DICTIONARY_DIALOG": {
        "HEADER": {
          "CREATE": "Добави термин",
          "EDIT": "Редактирай термин",
          "DESCRIPTION": "Терминът по-долу се прилага задължително при AI превода на статиите във вашия помощен център.",
          "PORTAL": "Портал",
          "PRIMARY_LANGUAGE": "Основен език"
        },
        "FORM": {
          "TERM": {
            "LABEL": "Термин ({locale})",
            "PLACEHOLDER": "Inbox",
            "ERROR": "Терминът е задължителен"
          },
          "DESCRIPTION": {
            "LABEL": "Контекст / бележки (незадължително)",
            "PLACEHOLDER": "Кога и как се използва този термин, за да помогне на преводача да го разграничи еднозначно."
          },
          "TRANSLATIONS": "Преводи",
          "TRANSLATION_PLACEHOLDER": "Оставете празно, за да позволите на AI да превежда свободно",
          "AUTO_TRANSLATE": {
            "BUTTON": "Преведи всички автоматично",
            "CONFIRM": "Преведи на {count} езика с AI?",
            "CONFIRM_BUTTON": "Преведи",
            "CANCEL": "Отказ",
            "SUCCESS": "Преводите са генерирани — прегледайте и запазете",
            "ERROR": "Неуспешен автоматичен превод. Опитайте отново."
          }
        },
        "BUTTONS": {
          "CREATE": "Добави термин",
          "EDIT": "Запази",
          "CANCEL": "Отмени"
        },
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Терминът е добавен успешно",
            "ERROR_MESSAGE": "Неуспешно добавяне на термина. Опитайте отново."
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Терминът е обновен успешно",
            "ERROR_MESSAGE": "Неуспешно обновяване на термина. Опитайте отново."
          }
        }
      },
      "DELETE": {
        "CONFIRM": {
          "TITLE": "Изтриване на термин",
          "DESCRIPTION": "Сигурни ли сте, че искате да изтриете този термин? Той вече няма да бъде прилаган при превод.",
          "CONFIRM": "Изтрий"
        },
        "API": {
          "SUCCESS_MESSAGE": "Терминът е изтрит успешно",
          "ERROR_MESSAGE": "Неуспешно изтриване на термина. Опитайте отново."
        }
      }
    }
  }
}
